import React from 'react';
import Message from '../@base/Message';
import style from './MessageNotification.module.css';

const MessageNotification = (props) => (
  <div className={style.MessageNotification}>
    <Message
      classes={props.type || null}
      content={props.content || null}
      hideClose={props.hideClose || null}
    />
  </div>
);

export default MessageNotification;
